<template>
  <div class="header-container">
    <div class="l-content" @contextmenu.prevent="rightClick">
      <el-button icon="el-icon-menu" size="medium" style="margin-left: 15px" @click="handleMenu"></el-button>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="padding-left:20px;" >
        <el-breadcrumb-item v-for="item in tags" :key="item.path" :to="{ path: item.path }" >
          {{ item.label }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="r-content">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
           <img class="user_img" :src="headerAvatar" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">修改密码</el-dropdown-item>
          <el-dropdown-item command="b">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%" @close="closeDialog()">
      <el-form :model="updatePassword" :rules="passwordRules" ref="passwordForm" label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input type="password" v-model="updatePassword.oldPassword" placeholder="请输入原密码" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="updatePassword.newPassword" placeholder="请输入新密码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmitFormData('passwordForm')">确定</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import BRAND from '@/config/brand'

export default {
  name: 'Header',
  data() {
    const checkPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        this.$http.post('/admin/checkPassword', this.updatePassword)
          .then((res) => {
            if (res.data.data == 'false') {
              callback(new Error('旧密码输入错误'))
            } else {
              callback()
            }
          }).catch(console.error)
      }
    }
    return {
      dialogFormVisible: false,
      dialogFormSubmitVisible: false,
      updatePassword: {
        username: sessionStorage.getItem('username'),
        oldPassword: '',
        newPassword: ''
      },
      passwordRules: {
        oldPassword: [{ validator: checkPassword, trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      },
      currentAdminInfo: null,
    }
  },
  computed: {
    ...mapState({
      tags: state => state.tab.tabsList
    }),
    brandLogo() {
      return BRAND.logoUrl
    },
    headerAvatar() {
      const icon = this.currentAdminInfo && this.currentAdminInfo.icon
      if (icon) {
        return icon
      }
      return this.brandLogo
    }
  },
  mounted() {
    this.loadCurrentAdminInfo()
  },
  methods: {
    loadCurrentAdminInfo() {
      this.$http.get('/admin/getAdminInfo').then(res => {
        const data = res && res.data && res.data.data
        if (Array.isArray(data) && data.length > 0) {
          this.currentAdminInfo = data[0]
        } else {
          this.currentAdminInfo = null
        }
      }).catch(() => {
        this.currentAdminInfo = null
      })
    },
    rightClick() {},
    handleMenu() {
      this.$store.commit('collapseChange')
    },
    handleCommand(commond) {
      if ('a' === commond) {
        this.dialogFormVisible = true
      }
      if ('b' === commond) {
        this.$confirm('是否确认注销登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/login')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消注销'
          })
        })
      }
    },
    handleSubmitFormData(passwordForm) {
      this.updatePasswordParam(passwordForm)
    },
    updatePasswordParam(passwordForm) {
      this.$refs[passwordForm].validate((valid) => {
        if (valid) {
          if (this.dialogFormSubmitVisible) {
            return
          }
          this.dialogFormSubmitVisible = true
          this.$http.post('/admin/updatePassword', this.updatePassword)
            .then(() => {
              this.dialogFormVisible = false
              this.updatePassword = {
                username: sessionStorage.getItem('username'),
                oldPassword: '',
                newPassword: ''
              }
              this.dialogFormSubmitVisible = false
              this.$message({
                type: 'info',
                message: '修改成功'
              })
            }).catch(() => {
              this.dialogFormSubmitVisible = false
            })
        }
      })
    },
    closeDialog() {
      this.updatePassword = {
        username: sessionStorage.getItem('username'),
        oldPassword: '',
        newPassword: ''
      }
      this.dialogFormSubmitVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.header-container {
  height: 60px;
  background-color: #242f42;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .index {
    color: #fff;
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
  }

  .r-content {
    padding-right: 20px;

    .user_img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
      background: #fff;
    }
  }

  .l-content {
    display: flex;
    align-items: center;

    /deep/.el-breadcrumb__item {
      .el-breadcrumb__inner {
        font-weight: normal;

        &.is-link {
          color: #666;
        }
      }

      &:last-child {
        .el-breadcrumb__inner {
          color: #fff;
        }
      }
    }
  }

  .welcome {
    font-size: 12px;
    margin-left: 70%;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Header.vue